import React from 'react';
import {
  Router,
  Route,
  IndexRoute,
  IndexRedirect,
  hashHistory,
} from 'react-router';
import Login from './Login';
import Root from './Root';
import Loadable from 'react-loadable';
import Spinner from "./Spinner";


// import StationTagList from './Station/StationTagList';

import StationList from './Station/StationList';

// Unit
import UnitList from './Unit/UnitList';
import UnitModify from './Unit/UnitModify';

// Role
import RoleList from './Role/RoleList';
import RoleModify from './Role/RoleModify';
import RolePermissionList from './Role/RolePermissionList';

// Permission
import PermissionList from './Permission/PermissionList';
import PermissionAdd from './Permission/PermissionAdd';



// User
import UserList from './User/UserList';
import UserAdd from './User/UserAdd';
import UserEdit from './User/UserEdit';

// Parameter
import ParameterList from './Parameter/ParameterList';
import ParameterModify from './Parameter/ParameterModify';

// Parameter Type
import ParameterTypeList from './ParameterType/ParameterTypeList';
import ParameterTypeModify from './ParameterType/ParameterTypeModify';


import FolderModify from './Folder/FolderModify';
import FolderStationExport from "./Folder/StationExport/FolderStationExport";
import FolderStationImport from "./Folder/StationImport/FolderStationImport";

import FolderStationAdd from './Folder/FolderStationAdd';
import FolderStationEdit from './Folder/FolderStationEdit';

import TagList from './Tag/TagList';
import TagModify from './Tag/TagModify';

import Monitoring from './Monitoring';
import MonitoringTabular from './Monitoring/MonitoringTabular2';
import MonitoringRealTime from './Monitoring/MonitoringRealTIme';
// import Map from './Map';
import Map from './Map/IndexLeaflet';
import auth from '../libs/auth';
import { checkRolePermission, checkStationPermission } from '../libs/checkPermission';

import ImagesRoute from "./Images/routes";

import { MaintenanceRoute } from './Maintenance/routes';
import { clearLocalStorage } from "../libs/localStorage";
import UserProfile from "./User/UserProfile";
import Preferences from "./Preferences";

import StationPermissionList from "./Permission/StationPermissionList";
import ParameterPermissionList from "./Permission/ParameterPermissionList";
import UserPermission from "./User/UserPermission";
import TagParameter from "./Tag/TagParameter";

import { ConfigurationRoute } from './SystemConfiguration/routes';
import { IDaqRoute } from "./IDaq/routes";
import { StationRoute } from './Station/routes';
import { QCRoutes } from './QCRule/routes';
import { DataDeliveryRoutes } from './DataDelivery/routes';
import { HydrologyRoutes } from './Hydrology/routes';
import { ToolsRoutes } from './Tools/routes';
import { InventoryRoutes } from './Inventory/routes';
import { AnalysisRoutes } from './Analysis/routes';
import { DAQRoutes } from './DataSource/routes';


const Home = Loadable({
  loader: () => import('./Home'),
  loading: () => <Spinner />
});
const Station = Loadable({
  loader: () => import('./Station/Station'),
  loading: () => <Spinner />
});

const NotFound = () => <div>NotFound</div>;

function requireAuth(nextState, replace) {
  const pathname = '/login';
  if (!auth.loggedIn()) {
    window.localStorage.href_redirect = nextState.location.pathname;
    clearLocalStorage();
    replace({
      pathname,
      state: { nextPathname: nextState.location.pathname },
    });
  } else {
    let href = window.localStorage.href_redirect;
    if (!!href) {
      delete window.localStorage.href_redirect;
      replace(href);
    }
  }
}

function redirectIfAuthenticated(nextState, replace) {
  if (auth.loggedIn()) {
    replace({
      pathname: '/',
      state: { nextPathname: nextState.location.pathname },
    });
  }

}

function logout(nextState, replace) {
  clearLocalStorage();
  replace({
    pathname: '/login',
    state: { nextPathname: nextState.location.pathname },
  });
  setTimeout(() => {
    window.location.reload();
  }, 200);
}

const Routes = () => (
  <Router history={hashHistory}>
    <Route path="/login" component={Login} onEnter={redirectIfAuthenticated} />
    <Route path="/logout" onEnter={logout} />
    <Route path="/" component={Root} onEnter={requireAuth}>
      <Route component={Home}>
        <IndexRedirect to="monitoring/map" />
        <Route path="monitoring">
          <IndexRedirect to="map" />
          <Route path="map" component={Map} />
          <Route path="problem" component={Monitoring} />
          <Route path="tabular" component={MonitoringTabular} />
          <Route path="real-time" component={MonitoringRealTime} />
          {MaintenanceRoute()}
        </Route>

        <Route path="unit" component={checkRolePermission(UnitList)} name="view unit" >
          <Route path=":id" component={checkRolePermission(UnitModify)} name="modify unit" />
        </Route>

        <Route path="permission" component={PermissionList} />

        <Route path="role/:id/permission" component={RolePermissionList} />
        <Route path="role" component={checkRolePermission(RoleList)} name='view role'>
          {/* <Route path="add" component={checkRolePermission(RoleAdd)} name='modify role' /> */}
          <Route path="permission-add" component={checkRolePermission(PermissionAdd)} name='modify permission' />
          <Route path=":id" component={checkRolePermission(RoleModify)} name='modify role' />
        </Route>

        {/*<Route path="qc-rule" component={checkRolePermission(QCRuleList)} name="view qc-rule" >*/}
        {/*<Route path="add" component={checkRolePermission(QCRuleAdd)} name="modify qc-rule" />*/}
        {/*<Route path=":id" component={checkRolePermission(QCRuleEdit)} name="modify qc-rule" />*/}
        {/*</Route>*/}

        <Route path="user" component={checkRolePermission(UserList)} name="view user">
          <Route path="add" component={checkRolePermission(UserAdd)} name="modify user" />
          <Route path=':id/permission' component={UserPermission}>
            <IndexRedirect to='station' />
            <Route path='station' component={StationPermissionList} />
            <Route path='parameter' component={ParameterPermissionList} />
          </Route>
          <Route path=":userId" component={checkRolePermission(UserEdit)} name="modify user" />
        </Route>
        <Route path="profile" component={UserProfile} />

        <Route path="parameter-type" component={checkRolePermission(ParameterTypeList)} name="view parameter-type" >
          {/* <Route path="add" component={checkRolePermission(ParameterTypeAdd)} name="modify parameter-type" /> */}
          <Route path=":parameterTypeId">
            <IndexRoute component={checkRolePermission(ParameterTypeModify)} name="modify parameter-type" />
            <Route path="parameter">
              <Route path=":parameterId" component={ParameterModify} />
            </Route>
          </Route>
        </Route>
        {/*
        <Route path="parameter-type">
          <IndexRoute component={ParameterTypeList} />
          <Route path="add" component={ParameterTypeAdd} />
          <Route path=":parameterTypeId" component={ParameterTypeEdit} />
        </Route>
        */}


        <Route path="folder" component={checkRolePermission(StationList)} name='view station'>
          <Route path="export" component={checkRolePermission(FolderStationExport)} name='modify folder' />
          <Route path="import" component={checkRolePermission(FolderStationImport)} name='modify folder' />
          <Route path=":id" component={checkRolePermission(FolderModify)} name='modify folder' />
          <Route path=":id/station/add" component={checkRolePermission(FolderStationAdd)} name='modify station' />
          <Route path=":id/station/:stationId" component={checkRolePermission(FolderStationEdit)} name='modify station' />
        </Route>

        <Route path="station" component={checkRolePermission(StationList)} name='view station'>
          <IndexRoute />
          <Route path="add" component={checkRolePermission(FolderStationAdd)} name='modify station' />
        </Route>

        <Route path="tag" component={checkRolePermission(TagList)} name="view tag" >
          {/* <Route path="add" component={checkRolePermission(TagAdd)} name="modify tag" /> */}
          <Route path=":id" component={checkRolePermission(TagModify)} name="modify tag" />
          <Route path=":id/parameter" component={checkRolePermission(TagParameter)} name="modify tag" />
        </Route>

        <Route path="/daq">{DAQRoutes()}</Route>
        <Route path="analysis">{AnalysisRoutes()}</Route>
        <Route path='inventory'>{InventoryRoutes()}</Route>
        <Route path='qc'>{QCRoutes()}</Route>
        <Route path='tools'>{ToolsRoutes()}</Route>
        <Route path='configurations'>{ConfigurationRoute()}</Route>
        <Route path='export'>{DataDeliveryRoutes()}</Route>
        <Route path='hydrology'>{HydrologyRoutes()}</Route>
        <Route path='idaq' >{IDaqRoute()}</Route>
        <Route path='images' >{ImagesRoute()}</Route>
        <Route path='preferences' component={Preferences} />

      </Route>

      {StationRoute()}

      <Route path="*" component={NotFound} />
    </Route>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js